import script from "./DrawingWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingWindow.vue?vue&type=script&setup=true&lang=js"

import "./DrawingWindow.vue?vue&type=style&index=0&id=1c4f382b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c4f382b"]])

export default __exports__